import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { DiveIN } from '../../../../shared/models/component-messages/diveIN/diveIN';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { LogService } from '../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn } from '../../../common/models/type.ann';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { TypeAnn_DIVER_G1 } from '../models/TypeAnn_DIVER_G1';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';


@Component({
  selector: 'app-form-divers-initial',
  templateUrl: './formDiversInitial.component.html'
})
export class FormDiversInitialComponent implements OnInit {

  private LOG: LogService = new LogService(FormDiversInitialComponent);

  @Input() form: FormGroup;
  @Input() indexPage: any;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public initial = new TypeAnn_DIVER_G1();
  public createForm = false;
  public diveIn = new DiveIN();
  public ann = new TypeAnn();

  public steps = [4, 5, 6, 7, 8, 9, 10, 11];
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private annonceurService: AnnonceurService,
    private spinner: SpinnerVisibilityService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService
    ) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 12 }, (_, index) => index + 1);
    this.initForm();
  }

  private initForm() {
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string'&& !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4) {
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        }
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.createForm = true;
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.DIVE_IN, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.ann = formData.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.DIVE_IN] + '.json');
          this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.DIVE_IN] + '.json');
          this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.DIVE_IN] + '.json');
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  public getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_TypeAnn_DIVER_G1';
  }

  getUidCommon(indexPage) {
    return (
      '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn'
    );
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(
      this.diveIn.step + indexPage
    )
      ? this.diveIn.step + indexPage
      : this.diveIn.commonStep + indexPage;
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]:
        return [];
      case this.steps[1]:
        return [];
      case this.steps[2]:
        return [];
      case this.steps[3]:
        return [];
      case this.steps[4]:
        return [];
      case this.steps[5]:
        return [];
      case this.steps[6]:
        return [];
      case this.steps[7]:
        return [];
    }
  }

}
